import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Dealer} from '@ox/typings';
@Component({
  selector: 'webu-confirm-save',
  templateUrl: './confirm-save-webu.component.html'
})
export class ConfirmSaveWebuComponent {
  @Input() dealer:Dealer;
  @Output() dealerChange = new EventEmitter();

  public status = '';

  cancel() {
    this.dealerChange.emit('cancel');
  }

  save() {
    this.status = 'processing';
    this.dealerChange.emit('save');
  }
}
